import * as React from "react";

function EUHybrid(props) {
  return (
        <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
                <path d="M14 0.499996C21.4541 0.499996 27.5 6.5448 27.5 14C27.5 21.4541 21.4541 27.5 14 27.5C6.54481 27.5 0.5 21.4541 0.5 14C0.5 6.54478 6.54478 0.499996 14 0.499996Z" fill="#B7E9B4" stroke="#58C150"/>
                <path d="M8.78276 6.71999C8.78276 6.71999 7.84986 9.68239 6.21813 14.0011C4.58415 18.3198 6.44995 21.28 8.78276 21.28C11.1156 21.28 13.4473 18.8126 11.7237 14.8646C10.0035 10.9144 8.78276 6.71999 8.78276 6.71999Z" fill="#212B36"/>
                <path d="M15.0329 21.28L17.7218 15.5594H13.44L21.7144 6.71999L19.2382 12.4934H23.52L15.0329 21.28Z" fill="#FFFA10"/>
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="28" height="28" fill="white"/>
                </clipPath>
            </defs>
        </svg>
  );
}

export default EUHybrid;
